import healthcare from "../assets/healthcare.jpg"
import identity from "../assets/identity.jpg"
import travel from "../assets/travel.jpg"
import renegade from "../assets/renegade.png";
import wallet from "../assets/wallet.jpg"

export const caseStudyData = [
    {
        id: 1,
        image: renegade,
        name: "Renegade Heating and Cooling",
        description: "Custom website for a local HVAC company. Built with Astro.",
        link: "https://renegadeairhvac.com/",
    },
    {
        id: 2,
        image: healthcare,
        name: "Health Care Department",
        description: "Modernized legacy software, building a new React front-end, GraphQL BFF and Node microservices to integrate with existing mainframe. Handled tens of thousands of requests daily with minimal production errors.",
    },
    {
        id: 3,
        image: travel,
        name: "Travel Booking Sevice",
        description: "Developed features and components in React, conforming to existing component patterns. Built properties and rates pages for an online travel agency.",
    },
    {
        id: 4,
        image: identity,
        name: "Identity Protection Platform",
        description: "Contributed to authentication/authorization flow for Identity protection platform using Next.js and Auth0. Responsible for building and testing pages and components, integrating and testing in multiple environments, and monitoring production incidents.",
    },
    {
        id: 5,
        image: wallet,
        name: "Casino Mobile Application",
        description: "Helped create mobile application for casino guests to add money to a digital wallet, connect to slot machines via 3rd party API, and deposit/withdrawal from machines using virtual wallet. Built with React Native. Uploaded to apple and android app stores.",
    },

];
